  <div class="mainRouterOutlet" #mainRouterOutlet>
    <router-outlet></router-outlet>   
  </div>

  <dx-load-panel
    #loadPanel
    shadingColor="rgba(0,0,0,0.4)"
    [position]="{ of: '#mainRouterOutlet' }"
    [(visible)]="progressChange.isLoadingProgressShow"
    [showIndicator]="true"
    [showPane]="true"
    [shading]="true"
    [closeOnOutsideClick]="false"
   >
</dx-load-panel>
